var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHugeiconsFileUpload1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 12V14.544C4 17.789 4 19.412 4.886 20.511C5.06494 20.7329 5.26709 20.9351 5.489 21.114C6.59 22 8.211 22 11.456 22C12.161 22 12.514 22 12.837 21.886C12.9037 21.862 12.9693 21.8347 13.034 21.804C13.344 21.656 13.593 21.407 14.092 20.908L18.828 16.172C19.407 15.594 19.695 15.305 19.848 14.937C20 14.569 20 14.161 20 13.343V10C20 6.229 20 4.343 18.828 3.172C17.656 2.001 15.771 2 12 2M13 21.5V21C13 18.172 13 16.757 13.879 15.879C14.757 15 16.172 15 19 15H19.5",
    stroke: "#39ACE7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 5C9.41 4.393 7.84 2 7 2C6.16 2 4.59 4.393 4 5M7 3V10",
    stroke: "#39ACE7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHugeiconsFileUpload1);
export default __webpack_public_path__ + "static/media/hugeicons_file-upload1.aadcf7db82d87855ff13528dc9ea4a40.svg";
export { ForwardRef as ReactComponent };